import { Controller } from "@hotwired/stimulus"

// Makes the header's "Join the waitlist" button work from any page. Every
// page except home links here via its own href (root_path(anchor:
// "waitlist")) as a plain, JS-free fallback. When JS is available, this
// controller instead jumps straight to *this* page's own waitlist form
// (most pages render one at the bottom) and focuses its email field, so
// visitors don't get bounced to the homepage unnecessarily.
//
// Pages with no waitlist form of their own (e.g. privacy policy) fall
// through to the href and land on the homepage's form instead — see the
// document-level turbo:load listener below, which focuses it on arrival.
// That's a plain listener rather than this controller's connect() because
// Turbo updates the URL hash asynchronously relative to when the new
// page's elements (and their controllers) connect, so checking
// location.hash from connect() can race and see the stale, pre-hash URL.
export default class extends Controller {
  jump(event) {
    const target = document.getElementById("waitlist")
    if (!target) return // no form on this page — let the href fall through to the homepage

    event.preventDefault()
    closeMobileNav() // this click never navigates, so the mobile overlay (if open) has nothing else to close it
    target.scrollIntoView({ behavior: "smooth", block: "center" })
    window.history.replaceState(null, "", "#waitlist")
    window.setTimeout(() => focusWaitlistEmailField(), 400)
  }
}

function focusWaitlistEmailField() {
  document.getElementById("waitlist")?.querySelector('input[type="email"]')?.focus()
}

function closeMobileNav() {
  const header = document.querySelector(".site-header.is-open")
  if (!header) return
  header.classList.remove("is-open")
  header.querySelector(".nav-toggle")?.setAttribute("aria-expanded", "false")
}

document.addEventListener("turbo:load", () => {
  if (window.location.hash === "#waitlist") focusWaitlistEmailField()
})
